const ReviewsSlider = () => {
  const selectors = {
    section: ".reviews-slider",
    track: ".js-reviews-slider-track",
    pagination: ".js-reviews-slider-pagination",
    btnPrev: ".js-reviews-slider-prev",
    btnNext: ".js-reviews-slider-next"
  };

  async function init(sectionId) {
    const Swiper = window.themeCore.utils.Swiper;

    const sections = [...document.querySelectorAll(selectors.section)].filter(
      (el) => !sectionId || el.closest(`#shopify-section-${sectionId}`)
    );

    sections.forEach((section) => {
      const track = section.querySelector(selectors.track);
      if (!track) return;

      const btnPrev = section.querySelector(selectors.btnPrev);
      const btnNext = section.querySelector(selectors.btnNext);
      const pagination = section.querySelector(selectors.pagination);
      const isDynamicBullets = track.dataset.dynamicPagination === "true";
      const swiper = new Swiper(track, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        pagination: {
          el: pagination,
          clickable: true,
          bulletElement: "button",
          dynamicBullets: isDynamicBullets
        },
        breakpoints: {
          575: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        }
      });

      if (btnPrev) btnPrev.addEventListener("click", () => swiper.slidePrev());
      if (btnNext) btnNext.addEventListener("click", () => swiper.slideNext());
    });
  }

  return Object.freeze({ init });
};

const action = () => {
  window.themeCore.ReviewsSlider = window.themeCore.ReviewsSlider || ReviewsSlider();
  window.themeCore.utils.register(window.themeCore.ReviewsSlider, "reviews-slider");
};

if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener("theme:all:loaded", action, { once: true });
}
